import AUApi from '@/api';
import { findSperrDate } from '@/SperreHelper';

export declare interface TimeLineDayUIData extends DataPageUIData {
    wochenTag: string; // = ""
    monat: string;// = "-"
    year: string;// = "-"
    timeLine?: boolean; //?? initialized ?
    dialogDate?: boolean;
    showDialogLocal?: boolean;
    showBtnNacherfassung?: boolean;
    showEditDelete?: boolean;
    hidden?: boolean; // nur für buttons ?
    holiday?: Holiday;
    titleColor: string;// "dvhBackground";
    name: string;
    picker: string; // = new Date().toISOStringWithTZ().substr(0, 10);

    showReisekostenMutable?: boolean;
    antragMoeglich?: boolean; //ref<boolean>(checkBegriff("Web_ST_Antrag_erzeugen"));
    warningBtnVisible?: boolean;
    warningBtn: string // = "warning";
    sperre: boolean; // dürfen Tage nicht mehr bearbeitet werden- dann wird sperre gesetzt
    // sperre ist zB Ampel Sperre nach FREIGABE... diese tage dürfen NICHT geändert werden!
    isApiBusy: boolean;

    calcToday: boolean;// = false;

    reisen: boolean;// = false;

    reiseBeginn: boolean;// = false;
    tempZeitbereich?: APIZeitbereich;
    bdeAntrag?: boolean;// = false;
    bdeErlaubt: boolean;// = false;
    maxDate: string;// = new Date().toISOStringWithTZ().substr(0, 10);
    editZeitbereich?: APIZeitbereich;// | null = null;
    queryAIC?: number;// | null;
    colorZulagen: string;// = "grey";
    items?: ListItems[];// | null = null;
    heightLocal: number;// = ref<number>(props.contentHeight ?? innerHeight);
    widthLocal: number;// = ref<number>(props.contentWidth ?? 300);
    sheet?: boolean;
    textReise: string;// = "hallo Reise"
    colorManZulagen: string;// = "grey";

    tiles: { img: string, title: string, open: () => void }[];

    tag: number;

    lastRefresh?: string;
}
export declare interface TimeLineMonthProps extends TimeLineProps {
    day?: Date;
    nameUebergabe?: string;
    expandPanel?: boolean;
    contentHeight?: number;
    contentWidth?: number;
}
export declare interface TimeLineDayProps extends TimeLineProps {
    day?: Date;
    showName?: boolean;
    nameUebergabe?: string;
    contentHeight?: number;
    contentWidth?: number;
    minDate?: string;
    freigabeAntrag?: boolean;
}

declare interface calcItem {
    color?: string;
    icon?: string;
    text?: string;
    modell?: string;
}

export declare interface TimeLineMonthUIData extends DataPageUIData {
    monat: string;// = ref<string>();
    year: string;// = ref<string>();

    timeLine?: boolean;// = ref<boolean>(false);
    window: number;//: any = 0;
    editaic: number;//: any;
    showDialogLocal: boolean;//: boolean = false;
    showDialog: boolean;//: boolean = false;
    showDialog1: boolean;//: boolean = false;
    lastRefresh?: string;//: string | null = null;
    editZeitbereich: APIZeitbereich;// = ref<APIZeitbereich | null>(null);
    printBtnVisible: boolean;//: boolean = false;
    printLohn: boolean;//= ref<boolean>(false);
    zulagenBtnVisible: boolean;//= ref<boolean>(false);
    showDef?: boolean;// = false;
    titleColor: string; // "dvhBackground";
    items: ListItems[];// = ref<ListItems[]>([]);
    vecStamm: any[];
    calcItem?: calcItem;
    heightLocal?: number;// = ref<number>(props.contentHeight ?? innerHeight);
    sheet: boolean;// = ref<boolean>(false);
    isApiBusy?: boolean;// = ref<boolean>(false);
    wochenTag: string
}

export declare interface TimeLineMonthProps extends TimeLineProps {
    day?: Date;
    expandPanel?: boolean;
    nameUebergabe?: string;
    contentHeight?: number;
}

export interface TimeLineMonthMonthParameters extends DataPageParameter {

}

export declare interface TimeLineProps {
    aic?: number;
    query?: string;
    queryEdit?: string;
    zeitbereich?: APIZeitbereich;
    showError?: boolean;
    showTagessaldo?: boolean;
    showNacherfassung?: boolean;
    showProjektstunden?: boolean;
    showReisekosten?: boolean;
    admin?: boolean;
    showClose?: boolean;
    showManZulagen?: boolean;
}


export declare interface TimelineCarouselParameter extends DataPageParameter {
    queryEdit: string;
    admin?: boolean;
    showTagessaldo?: boolean;
    showNacherfassung?: boolean;
    showProjektstunden?: boolean;
    showReisekosten?: boolean;
    showManZulagen?: boolean;
}

export declare interface TimeLineCarouselUIData extends DataPageUIData {
    nameUebergabe?: string;
    scrollToDate: Date;
    myHeight: number;
    myWidth: number;
    activeTab: number;
    dates: Date[];
    actDates: Date[];
    today: Date;
    pages: number;
    timelinesInPage: number;
    showCarousel: boolean;

    lastRefresh?: string;
    innerHeight: number;// = window.innerHeight;

    minWidth: number;
    maxWidth: number;
    minDate: string;

    refreshHidden: Date;
    showError?: boolean;
}

export type calcDatesFunction = (uiData: TimeLineCarouselUIData, props: TimeLineProps) => void;
export function getSperrDate(uiData: TimeLineCarouselUIData, params: TimelineCarouselParameter, vgSicht?: boolean) {
    const aic = AUApi.Current.user.aic;

    if (params.query) {
        const t = findSperrDate(params.query, aic, vgSicht);
        if (t) {
            const sperrDate = t.sperrDatum;
            return new Date(sperrDate);
        }
    }
}
export function getSperrDateDay(params: DataPageParameter, vgSicht?: boolean) {
    const aic = AUApi.Current.user.aic;

    if (params.query) {
        const t = findSperrDate(params.query, aic, vgSicht);
        if (t) {
            const sperrDate = t.sperrDatum;
            return new Date(sperrDate);
        }
    }
}
export function getPages(uidata: TimeLineCarouselUIData) {
    if (uidata.dates.length % uidata.timelinesInPage > 1) {
        return Math.floor(uidata.dates.length / uidata.timelinesInPage) + 1;
    }
    return Math.round(uidata.dates.length / uidata.timelinesInPage);
}

export function mountedTimeline(uiData: TimeLineCarouselUIData, props: TimeLineProps, calcDates: calcDatesFunction) {
    uiData.showCarousel = false;
    uiData.dates = [];
    uiData.myHeight = window.innerHeight - 100;
    if (window.innerWidth < 600) {
        uiData.timelinesInPage = 1;
        uiData.myWidth = window.innerWidth - 10;
    } else if
        (window.innerWidth > 600) {
        const max = window.innerWidth;
        let breite = 450;
        if (props.showReisekosten) {
            breite = 380;
            uiData.myWidth = 370;
        } else if (props.showTagessaldo) {
            breite = 350;
            uiData.myWidth = 350;
        }
        let anzahl = max / breite;
        anzahl = Math.floor(anzahl);
        uiData.timelinesInPage = anzahl;
    }

    calcDates(uiData, props);
    const pages = uiData.dates.length / uiData.timelinesInPage;
    uiData.pages = Math.ceil(pages);
    const today = new Date();
    gotoDate(uiData.scrollToDate ?? today, uiData);

}

export function gotoDate(date: Date | string, uidata: TimeLineCarouselUIData) {
    uidata.showCarousel = false;
    if (!date) {
        console.log("cannot go to undefined Date!");
        return;
    }
    if (typeof date === "string") {
        date = new Date(date);
    }
    if (!date.toISOStringWithTZ) {
        console.log("cannot go to not parsable Date!");
        return;
    }
    const iso = date.toISOStringWithTZ().substr(0, 10);
    // let dayIndex = this.dates.length;
    let dayIndex =
        uidata.dates.findIndex(dt => dt.toISOStringWithTZ().substr(0, 10) === iso) -
        1;
    // falls dayindex negativ ist  mit 1 des Monats nochmal rechnen... sonst kommt blödsinn raus!
    // habe bei UNGERADEN Anzahl Tagen ein Problem - wenn zB 2 Tage angezeigt werden sollen..
    if (dayIndex < 0) {
        const myDate = date.firstOfMonth();
        const isomyDate = myDate.toISOStringWithTZ().substr(0, 10);
        dayIndex =
            uidata.dates.findIndex(dt => dt.toISOStringWithTZ().substr(0, 10) === isomyDate) -
            1;
    }
    const tabIndex = Math.floor(dayIndex / uidata.timelinesInPage);
    uidata.activeTab = Math.max(0, tabIndex);
    uidata.showCarousel = true;
}


